import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=5031b956"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5031b956')) {
      api.createRecord('5031b956', component.options)
    } else {
      api.reload('5031b956', component.options)
    }
    module.hot.accept("./Stats.vue?vue&type=template&id=5031b956", function () {
      api.rerender('5031b956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Stats.vue"
export default component.exports